import Button from "../../Button";
import React, { useContext,useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import constants from "../../../constants";
import TestSvgIcon from "../../../Svg/TestSvgIcon";
import { MockTestPageContext } from "../../../context/MockTestPageContext";
import MockTestLibraryHooks from "../../../Hooks/Mock/Student/MockTestLibraryHooks";
import MockTestDetailsHooks from "../../../Hooks/Mock/Student/MockTestDetailsHooks";

export default function InterviewLibrary() {
  const MockTestPageCxt = useContext(MockTestPageContext);

  const MockTestLibraryHks = MockTestLibraryHooks();
  const companyId = parseInt(localStorage.getItem("companyId"), 10);
  useEffect(()=>{
    MockTestPageCxt.setSearchText("");
  },[companyId]);
  MockTestDetailsHooks();

  return (
    <div className="interviewLibraryMainContainer">
      {MockTestPageCxt.searchMockTest.map((test) => (
        <div key={test.id} className="interviewLibraryGrid">
          <div>
            <div className="interviewLibraryGridHeader">
              <div className="interviewLibraryGridHeaderTitle">{test.name}</div>
              {!test.hasOwnProperty("toc") || test.thumbnail === null ? (
                <TestSvgIcon
                  videoQn={test.videoqn || test.aiMode}
                  autoEval={test.autoeval}
                  libType={
                    test.thumbnail !== null
                      ? test.libtype
                      : constants.libTypeIds.LEARNINGPATH
                  }
                />
              ) : (
                <Avatar
                  src={test.thumbnail}
                  style={{ width: "28px", height: "30px", padding: 0 }}
                />
              )}
            </div>
            <div className="interviewLibraryGridSubHeader">
              <div className="interviewLibraryGridSubHeaderTestTitle">
                {MockTestLibraryHks.getTestType(test)}
                <div className="interviewLibraryGridSubHeaderTestQuestionCount">
                  ({test.questionscount} Questions)
                </div>
              </div>
              {/* <div className="interviewLibraryGridSubHeaderTestDuration">
                {MockTestLibraryHks.getTime(test.testduration)}
              </div> */}
            </div>
            <div className="interviewLibraryGridTestDescription">
              {test.description}
            </div>
            <div className="interviewLibraryGridTestTagsDiv">
              {test.hasOwnProperty("tags") &&
                test.tags !== "" &&
                test.tags !== null &&
                test.tags !== "null" && (
                  <div className="interviewLibraryGridTestTags">
                    {test.tags}
                  </div>
                )}
            </div>
          </div>
          <div className="interviewLibraryGridFooter">
            <div className="interviewLibraryGridSubHeaderTestDuration">
                {MockTestLibraryHks.getTime(test.testduration)}
            </div>
            <Button
              size="sm"
              onClick={() => MockTestLibraryHks.handleTest(test)}
              icon={{
                type: "trailing",
                icon: (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.3346 7.44277C18.3346 6.93792 18.3346 6.6855 18.2348 6.56861C18.1482 6.46719 18.0182 6.41337 17.8853 6.42383C17.732 6.43589 17.5535 6.61438 17.1966 6.97136L14.168 9.99996L17.1966 13.0286C17.5535 13.3855 17.732 13.564 17.8853 13.5761C18.0182 13.5866 18.1482 13.5327 18.2348 13.4313C18.3346 13.3144 18.3346 13.062 18.3346 12.5572V7.44277Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1.66797 8.16663C1.66797 6.7665 1.66797 6.06643 1.94045 5.53165C2.18014 5.06124 2.56259 4.67879 3.03299 4.43911C3.56777 4.16663 4.26784 4.16663 5.66797 4.16663H10.168C11.5681 4.16663 12.2682 4.16663 12.8029 4.43911C13.2734 4.67879 13.6558 5.06124 13.8955 5.53165C14.168 6.06643 14.168 6.76649 14.168 8.16663V11.8333C14.168 13.2334 14.168 13.9335 13.8955 14.4683C13.6558 14.9387 13.2734 15.3211 12.8029 15.5608C12.2682 15.8333 11.5681 15.8333 10.168 15.8333H5.66797C4.26784 15.8333 3.56777 15.8333 3.03299 15.5608C2.56259 15.3211 2.18014 14.9387 1.94045 14.4683C1.66797 13.9335 1.66797 13.2334 1.66797 11.8333V8.16663Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                ),
                nospace: true,
              }}
              hierarchy={{
                type: "primary",
                buttonText:
                  test.status === constants.PROGRESS_STATUS.IN_PROGRESS &&
                  test.libtype === constants.libTypeIds.CODING_CHALLENGE
                    ? "Resume test"
                    : "Take test",
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
